module.exports = __webpack_public_path__ + "static-portal/img/hierarchy2.81d4ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome/hierarchy2.png
// module id = UnDm
// module chunks = 4